export default {
  chatTicketCosts: {},
  chatTicketsOpen: {},
  chatTicketsClose: {},
  sumTypeCosts: {
    'costs_by_business': 0,
    'costs_by_utility' : 0,
    'costs_by_user' : 0
  },
  chatTicketTypes: {
    'chatTicketsOpen': true,
    'chatTicketsClose': false
  }
}
